import { getContext } from '@fiverr-private/fiverr_context';
import { INDUSTRY_RECOMMENDATIONS_SOURCE } from '../../constants';
import { isBusinessDomain } from '../business';

export const shouldDisplayIndustryFilter = () => {
    const { isMobile, queryParameters = {} } = getContext();
    const isIndustryRecommendationsSource = queryParameters.source === INDUSTRY_RECOMMENDATIONS_SOURCE;

    return !isMobile && (isBusinessDomain() || isIndustryRecommendationsSource);
};
